import { useEffect, useState } from 'react';

import type { Recording } from '@hotjar/webapp/domains/recordings/types';

export const useGetNotWatchedRecordings = (
  recordings: Recording[],
  offset?: number,
): Recording[] => {
  const [notWatchedRecordings, setNotWatchedRecordings] = useState<Recording[]>(recordings);

  useEffect(() => {
    const notWatchedRecordings = recordings.filter((recording) => !recording.watched);
    // Prioritize displaying the not watched recordings
    const recordingsToSlice = notWatchedRecordings.length > 0 ? notWatchedRecordings : recordings;

    const effectiveOffset = offset ?? recordings.length;

    setNotWatchedRecordings(recordingsToSlice.slice(0, effectiveOffset));
  }, [recordings, offset]);

  return notWatchedRecordings;
};
